
import React from "react";
import { ChefHat } from "lucide-react";
import { useTranslation } from "react-i18next";

interface AuthHeaderProps {
  isSignUp: boolean;
}

const AuthHeader: React.FC<AuthHeaderProps> = ({
  isSignUp
}) => {
  const { t } = useTranslation(['auth']);
  
  return <div className="flex flex-col items-center mb-8 animate-fade-in">
      <h1 className="text-2xl font-medium">
        {isSignUp ? t('auth:createAccount') : t('auth:signIn')}
      </h1>
      <p className="text-muted-foreground text-sm mt-1">
        {isSignUp ? t('auth:noAccount') : t('auth:hasAccount')}
      </p>
    </div>;
};

export default AuthHeader;
